/**
 * "Montando seu plano" — a cortina entre a última resposta e o app.
 *
 * Fonte: handoff/redesign/Objetivo.dc.html (bloco `wFinal` / `montando`).
 *
 * O QUE ELA COBRE, exatamente: o `saveUserObjective`, o registro do aceite e
 * o disparo da geração. É coisa de dois a três segundos — e é por isso que o
 * checklist marca em 0,7 / 1,5 / 2,3s. A geração de verdade leva minutos e
 * NÃO acontece aqui: ela segue em segundo plano, e quem a mostra são os dois
 * botões flutuantes da esquerda. Fingir aqui uma barra de progresso de três
 * minutos seria desenhar uma espera que a pessoa não precisa esperar.
 */

import React, { useEffect, useState } from 'react';

import Loader from '../../design/components/Loader/Loader';
import { Check } from './widgets/Widgets.jsx';
import s from './MontandoPlano.module.scss';

const ETAPAS = [
  { texto: 'Calculando suas calorias e macros', em: 700 },
  { texto: 'Escolhendo exercícios pro seu foco', em: 1500 },
  { texto: 'Distribuindo os treinos na semana', em: 2300 },
];

export default function MontandoPlano() {
  const [feitas, setFeitas] = useState(0);

  useEffect(() => {
    const timers = ETAPAS.map((etapa, i) =>
      setTimeout(() => setFeitas((n) => Math.max(n, i + 1)), etapa.em)
    );
    return () => timers.forEach(clearTimeout);
  }, []);

  return (
    <div className={s.cortina} role="status" aria-live="polite">
      <div className={s.card}>
        <div className={s.cabecalho}>
          <Loader tamanho={64} />
          <div className={s.titulos}>
            <span className={s.titulo}>Montando seu plano</span>
            <span className={s.sub}>Treino e dieta, do seu jeito</span>
          </div>
        </div>

        <div className={s.lista}>
          {ETAPAS.map((etapa, i) => {
            const ok = feitas > i;
            return (
              <div key={etapa.texto} className={s.item}>
                <span className={`${s.marca} ${ok ? s.marcaOk : ''}`}>
                  {ok && <Check tamanho={12} />}
                </span>
                <span className={`${s.itemTexto} ${ok ? s.itemTextoOk : ''}`}>
                  {etapa.texto}
                </span>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
